import Marquee from "react-fast-marquee";
import { CLIENTS } from "@/data/site";

// Client logos: real brand marks (in their original colors) — the one deliberate
// color moment on an otherwise black-and-white site. Sources are pre-trimmed and
// every logo renders at one uniform height (extreme wides capped by max-width);
// missing sources fall back to a colored wordmark.
export const ClientLogos = ({ speed = 34 }) => (
  <div data-testid="client-logos" className="w-full">
    <Marquee speed={speed} gradient={false} pauseOnHover>
      {CLIENTS.concat(CLIENTS).map((c, i) => (
        <div key={i} className="mx-10 md:mx-14 flex items-center justify-center h-14 md:h-16" title={c.name}>
          {c.file ? (
            <img
              src={c.file}
              alt={c.name}
              className="h-9 md:h-11 w-auto max-w-[150px] md:max-w-[180px] object-contain select-none"
              draggable={false}
              loading="lazy"
            />
          ) : (
            <span
              className="whitespace-nowrap select-none text-2xl md:text-3xl"
              style={{ color: c.color, fontWeight: 800, letterSpacing: "-0.02em" }}
            >
              {c.name}
            </span>
          )}
        </div>
      ))}
    </Marquee>
  </div>
);
